module.exports = __webpack_public_path__ + "img/52_46.088ae295.png";